import {useQuery} from 'react-query';

import getPromotedRequirement from '.';
interface IUseGetPromotedRequirementProps {
  guid?: string;
}
const useGetPromotedRequirement = ({guid}: IUseGetPromotedRequirementProps) => {
  const {data, isLoading} = useQuery(
    ['promoted-Requirement', guid],
    () => getPromotedRequirement(guid),
    {enabled: guid ? true : false},
  );
  return {data, isLoading};
};

export default useGetPromotedRequirement;
